import type { SearchScope, SingleGroup3sSearchScope, SingleGroupSearchScope, } from "owa-search-service";
import { SearchScopeKind } from "owa-search-service/lib/data/schema/SearchScope";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import { getListViewTypeForFolder } from "owa-mail-folder-store";
import type { FoldersSearchScope } from "owa-mail-search-utils/lib/types/FolderSearchScope";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import { logUsage } from "owa-analytics";
import type { MailboxInfo } from "owa-client-types";

export default function getSearchScopeListViewType(scope: SearchScope, mailboxInfo: MailboxInfo): ReactListViewType {
    if (scope?.kind) {
        switch (scope.kind) {
            case SearchScopeKind.PrimaryMailbox:
            case SearchScopeKind.ArchiveMailbox:
            case SearchScopeKind.SharedFolders:
                return getMailboxSearchScopeListViewType(scope);
            // Message View is used for Public Folders and PSTs
            case SearchScopeKind.PublicFolder:
            case SearchScopeKind.PstFile:
                return 1;
            case SearchScopeKind.AllMailboxes:
                // Cross-account results merge into one table, so honor the account-global list view
                // setting rather than forcing a single view.
                return (getUserConfiguration().UserOptions?.GlobalListViewTypeReact ?? 1);
            case SearchScopeKind.Group:
                return getSingleGroupSearchScopeListViewType(scope);
            default:
                throw new Error("Unregistered search scope");
        }
    }
    else {
        logUsage("SearchClientError", mailboxInfo, {
            Function: "getSearchScopeListViewType",
            Error: "kind is missing on search scope",
        });
        throw new Error("kind is missing on search scope");
    }
}

function getMailboxSearchScopeListViewType(folderSearchScope: FoldersSearchScope): ReactListViewType {
    return getListViewTypeForFolder(folderSearchScope.folderId);
}

function getSingleGroupSearchScopeListViewType(singleGroupSearchScope: SingleGroupSearchScope): ReactListViewType {
    return getListViewTypeForFolder((singleGroupSearchScope as SingleGroup3sSearchScope).folderId);
}
